var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Upload',{attrs:{"type":"drag","action":"/","before-upload":_vm.handleUpload}},[_vm._t("default")],2),_vm._t("info")],2)}
var staticRenderFns = []

export { render, staticRenderFns }